module.exports = __webpack_public_path__ + "759095fb31c085a24fb177dc2f17ac7e.svg";